import { Box, Typography } from '@mui/material'
import './style.scss'
import { colors } from '@/core/themeProvider/colors.ts'

const WeppaLoader = () => {
  return (
    <Box
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      gap={4}
    >
      <Typography sx={{ color: '#FDCA3C' }} variant="h3">
        WEPPA 2.0
      </Typography>
      <div
        className="weppa-loader"
        style={{ borderRightColor: colors.primary }}
      ></div>
    </Box>
  )
}

export default WeppaLoader
